// 书籍分类的统一列表：上传/编辑时可选，首页/书库按此浏览过滤。
export const CATEGORIES = [
  '都市', '校园', '乡村', '武侠', '仙侠', '玄幻', '奇幻',
  '历史', '军事', '科幻', '悬疑', '言情', '同人', '穿越',
  '系统', '游戏', '明星',
  'NTR', '人妻', '乱伦', '凌辱', '调教', '暴露', '恋物',
  '耽美', '堕落', '反差', '其它'
]

export default CATEGORIES
